import DEFAULT_THEME_VARIABLE from '~/constants/Whitelabel/DefaultThemeVariables';
import {
  DefaultThemeVariables,
} from '~/interfaces/whitelabelThemes/DefaultThemeVariables';

type MappingsType = {
  [key: string]: { overwrite: keyof DefaultThemeVariables, fallback?: string }
};

const VARIABLE_MAPPINGS: MappingsType = {
  '--primary-color': { overwrite: 'primaryColor' },
  '--secondary-color': { overwrite: 'secondaryColor' },
  '--grayscale-color-1': { overwrite: 'grayscaleColor1' },
  '--grayscale-color-2': { overwrite: 'grayscaleColor2' },
  '--grayscale-color-3': { overwrite: 'grayscaleColor3' },
  '--grayscale-color-4': { overwrite: 'grayscaleColor4' },
  '--grayscale-color-5': { overwrite: 'grayscaleColor5' },
  '--alert-color': { overwrite: 'alertColor' },
  '--rate-sheet-color-1': { overwrite: 'rateSheetColor1' },
  '--rate-sheet-color-2': { overwrite: 'rateSheetColor2' },
  '--rate-sheet-color-3': { overwrite: 'rateSheetColor3' },
  '--warning-color': { overwrite: 'warningColor' },
  '--success-color': { overwrite: 'successColor' },
  '--error-color': { overwrite: 'errorColor' },
  '--dark-color': { overwrite: 'darkColor' },
};

function setThemeVariables(brandCss: Record<string, string> = {}): void {
  const rootHtmlElement: HTMLElement = document.documentElement;

  Object.entries(VARIABLE_MAPPINGS).forEach(([cssVar, varNames]) => {
    const { overwrite, fallback } = varNames;
    const value = brandCss[overwrite]
      || (fallback ? brandCss[fallback] : null)
      || DEFAULT_THEME_VARIABLE[overwrite];
    rootHtmlElement.style.setProperty(cssVar, value);
  });
}

export default setThemeVariables;
